module.exports = __webpack_public_path__ + "static/media/universities-icon-3.cd07555b.svg";